var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vertical-bar" }, [
    _c(
      "div",
      {
        staticClass: "progress vertical-bar__progress",
        class: _vm.verticalBarType,
      },
      [
        _c(
          "div",
          {
            staticClass: "progress-bar vertical-bar__progress-bar",
            class: _vm.verticalBarAnimation,
            style: _vm.verticalBarStyle,
          },
          [
            _vm.size == "thick"
              ? _c("span", [
                  !_vm.text
                    ? _c("span", [_vm._v(_vm._s(_vm.value + "%"))])
                    : _c("span", [_vm._v(_vm._s(_vm.text))]),
                ])
              : _vm._e(),
          ]
        ),
      ]
    ),
    _vm.size != "thick"
      ? _c("div", { staticClass: "vertical-bar__value" }, [
          !_vm.text
            ? _c("span", [_vm._v(_vm._s(_vm.value + "%"))])
            : _c("span", [_vm._v(_vm._s(_vm.text))]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }